import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class KeywordsService {
  private http = inject(HttpClient);

  getKeywordsAndPrefixes() {
    return this.http.get<any>(environment.apiUrl + 'get-keywords-and-prefixes');
  }

  addPrefix(prefix: string) {
    return this.http.post<any>(environment.apiUrl + 'add-prefix', {
      prefix: prefix,
    });
  }

  addKeyword(keyword: string, prefixId: number) {
    return this.http.post<any>(environment.apiUrl + 'add-keyword', {
      keyword: keyword,
      prefixId: prefixId,
    });
  }
}
